import { render, staticRenderFns } from "./DialogoBuscarFornecedores.vue?vue&type=template&id=2ce5b820&scoped=true&"
import script from "./DialogoBuscarFornecedores.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5b820",
  null
  
)

export default component.exports